<ng-container *ngFor="let item of listHelp">
  <a *ngIf="item.type === LIST_HELP_TYPE.HELP && articles.get(item.flag)" [@collapse]
     class="help-item-box {{ articles.get(item.flag).thumbnail ? '' : 'no-img' }} {{ selected === item.flag ? 'on' : '' }}"
     (click)="onSelectHelp($event, item)">

    <div class="img-box"
         *ngIf="articles.get(item.flag).thumbnail && selected !== item.flag"> <!-- 썸네일 이미지가 없고, 선택되지 않은 경우 표시 -->
      <img src="{{ ApiUrl(articles.get(item.flag).thumbnail) }}" alt="이미지">
    </div>

    <div class="subject-box">
      <span [innerHTML]="articles.get(item.flag).title | resize | keepHtml"></span>
      <div class="close-btn"
           (click)="onClose(item, $event)">
      </div>
    </div>

    <div class="con-box"
         *ngIf="selected !== item.flag"
         [innerHTML]="articles.get(item.flag).brief | resize | keepHtml">
    </div>

    <!-- div class="con-box"
         [@collapse]="!selected"
         [innerHTML]="ApiUrlReplace(article.content) | keepHtml" -->
    <div class="con-box"
         *ngIf="selected === item.flag" [@collapse]
         [innerHTML]="ApiUrlReplace(articles.get(item.flag).content) | keepHtml">
    </div>

    <div class="open-btn"></div>
  </a>

  <a *ngIf="item.type === LIST_HELP_TYPE.OPTION" [@collapse]
     class="keyword-item-box">
    <div class="keyword-bottom-box">
      <app-option-item [optionItem]="GetOptionItem(item.content)"
                       [closeBtn]="true"
                       (onClose)="onClose(item)"></app-option-item>
      <div class="setting-box-more">좌상단의 <b>메뉴 버튼</b> &gt; <b>설정</b>에서도 바꿀 수 있습니다.</div>
    </div>
  </a>
</ng-container>
